module.exports = __webpack_public_path__ + "img/card_260720945.c8e34df2.png";